import "./ForgetPass.css";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UsersForgetPass, UsersRegister } from "../../Api/Services";
import { toast } from "react-toastify";

function ForgetPass() {
  const [inputValue, setInputValue] = useState({});
  const [flagLoading, setFlagLoading] = useState(false);

  const navigate = useNavigate();

  const LoginCheck = async () => {
    let validation = true;
    if (inputValue.userName === "") {
      toast.error("شماره همراه را وارد نمایید ");
      validation = false;
    }
    if (validation) {
      setFlagLoading(true);
      try {
        const UsersForgetPassData = await UsersForgetPass(inputValue);
        if (UsersForgetPassData.status && UsersForgetPassData.status === 200) {
          toast.success("کد احراز حویت ارسال گردید");
          navigate("/ForgetPassAccept");
        }
      } catch (error) {
        console.error("Error during login:", error);
      } finally {
        setFlagLoading(false);
      }
    }
  };
  const loginByEnter = (e) => {
    if (e.key === "Enter") {
      LoginCheck();
    }
  };

  return (
    <>
      {flagLoading && (
        <div
          className="scopeLoading d-flex justify-content-center align-items-center"
          style={{ height: window.innerHeight }}
        >
          <div className="lds-facebook">
            <div />
            <div />
            <div />
          </div>
        </div>
      )}
      <div className={flagLoading ? "startLoading" : "stateLoading"}>
        <div className="d-flex justify-content-center align-items-center">
          <div id="loginForm">
            <h2 className="text-center w-100 mt-2">فراموشی رمز عبور</h2>
            <div className="p-5" onKeyPress={loginByEnter}>
              <div className="d-flex justify-content-center mb-4">
                <input
                  className="loginInput"
                  type="text"
                  placeholder="شماره همراه"
                  value={inputValue.username}
                  onChange={(e) => {
                    setInputValue({
                      ...inputValue,
                      username: e.target.value,
                    });
                  }}
                />
              </div>
              <div className="d-flex justify-content-center">
                <button className="loginButton mt-3" onClick={LoginCheck}>
                  ارسال
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgetPass;
